import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { ARCHANGELS } from "@/lib/archangels";

/** Dynamic archangel chat page.
 *  Reads :id from URL (/anges/:id), picks the matching config,
 *  and renders a SacredChatPage with the right theme/suggestions/avatar. */
export default function Archange() {
  const { id } = useParams();
  const cfg = ARCHANGELS[id];
  if (!cfg) return <Navigate to="/anges-guides" replace />;

  return (
    <SacredChatPage
      persona={cfg.id}
      personaLabel={cfg.name}
      IconComponent={Sparkles}
      accent={cfg.accent}
      unlimited
      theme={cfg.theme}
      title={{
        fr: <>Archange <span className="italic" style={{ color: cfg.pageAccent }}>{cfg.title.fr}</span> {cfg.emoji}</>,
        en: <>Archangel <span className="italic" style={{ color: cfg.pageAccent }}>{cfg.title.en}</span> {cfg.emoji}</>,
      }}
      subtitle={cfg.subtitle}
      greeting={cfg.greeting}
      suggestions={cfg.suggestions}
      playlist={cfg.playlist}
    />
  );
}
